import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onMessageExtensionTrigger = action('onMessageExtensionTrigger', event => {
    return { event, owaType: 'messageExtensions' };
}) as OwaNovaActionUnion<'messageExtensions'>;
